import { useCallback, useState } from "react"

import {
  DisabledMode,
  DisabledModeT,
  FilterT,
  FilterType,
} from "./types/filter.types"
import { FullInterval } from "../../libs/dates/interval"
import { ALL_TIME_PRESET, listDateRangePresets } from "../../libs/dates/presets"

export interface UseDateFilterProps {
  key?: string
  label?: string
  persistInUrl?: boolean
  disabledMode?: DisabledModeT
  initialSelectedDateRange?: FullInterval | null
}

const presetsToDisplay = listDateRangePresets(false)

export function useLocalDateFilter({
  key = "date",
  label = "Date",
  disabledMode = DisabledMode.Future,
  initialSelectedDateRange = null,
}: Pick<
  UseDateFilterProps,
  "key" | "label" | "disabledMode" | "initialSelectedDateRange"
> = {}) {
  const [selectedDateRange, setSelectedDateRange] =
    useState<FullInterval | null>(initialSelectedDateRange)

  const onClear = useCallback(() => {
    setSelectedDateRange(null)
  }, [])

  const filter: FilterT = {
    key,
    value: label,
    type: FilterType.Date,
    defaultPreset: ALL_TIME_PRESET,
    presetsToDisplay,
    selectedDateRange,
    onSelectDateRange: setSelectedDateRange,
    onClear,
    disabledMode,
  }

  return { filter, selectedDateRange }
}
